import React, { useState } from 'react';
import { Check, Copy } from 'lucide-react';
import { cn } from '../cn';
export const CopyTextButton = ({ text, label = 'Copy', className, onCopied, }) => {
    const [copied, setCopied] = useState(false);
    if (!text.trim())
        return null;
    const handleCopy = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        try {
            await navigator.clipboard.writeText(text);
            setCopied(true);
            onCopied === null || onCopied === void 0 ? void 0 : onCopied(text);
            window.setTimeout(() => setCopied(false), 2000);
        }
        catch {
            /* clipboard unavailable */
        }
    };
    return (React.createElement("button", { type: "button", onClick: (e) => void handleCopy(e), className: cn('inline-flex shrink-0 items-center justify-center rounded border border-gray-200 p-1 text-gray-500 transition hover:bg-gray-50 hover:text-gray-700', copied && 'border-emerald-200 bg-emerald-50 text-emerald-700', className), "aria-label": copied ? 'Copied' : label, title: copied ? 'Copied' : label }, copied ? React.createElement(Check, { className: "h-3.5 w-3.5", "aria-hidden": true }) : React.createElement(Copy, { className: "h-3.5 w-3.5", "aria-hidden": true })));
};
export default CopyTextButton;
